class CustomerStoriesSlider {
  constructor(root) {
    this.root = root;
    this.viewport = root.querySelector('.cs-viewport');
    this.track = root.querySelector('.cs-track');
    this.slides = Array.from(root.querySelectorAll('.cs-slide'));
    this.prevBtn = root.querySelector('.cs-arrow--prev');
    this.nextBtn = root.querySelector('.cs-arrow--next');
    this.dotsWrap = root.querySelector('.cs-dots');

    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    this.desktopItems = parseInt(root.dataset.desktopItems, 10) || 2;
    this.mobileItems = parseInt(root.dataset.mobileItems, 10) || 1;

    this.currentIndex = 0;
    this.timer = null;

    if (!this.slides.length) return;

    this.root.style.setProperty('--cs-items-desktop', this.desktopItems);
    this.root.style.setProperty('--cs-items-mobile', this.mobileItems);

    this.mq = window.matchMedia('(max-width: 749px)');
    this.buildDots();
    this.bindEvents();
    this.goTo(0, false);
    this.startAutoplay();
  }

  get itemsPerView() {
    return this.mq.matches ? this.mobileItems : this.desktopItems;
  }

  get pageCount() {
    return Math.max(1, Math.ceil(this.slides.length / this.itemsPerView));
  }

  buildDots() {
    if (!this.dotsWrap) return;
    this.dotsWrap.innerHTML = '';
    for (let i = 0; i < this.pageCount; i++) {
      const dot = document.createElement('button');
      dot.className = 'cs-dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsWrap.appendChild(dot);
    }
    this.dots = Array.from(this.dotsWrap.querySelectorAll('.cs-dot'));
  }

  updateDots() {
    if (!this.dots) return;
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.currentIndex));
  }

  goTo(pageIndex, animate = true) {
    const pageCount = this.pageCount;
    this.currentIndex = ((pageIndex % pageCount) + pageCount) % pageCount;

    const itemsPerView = this.itemsPerView;
    const offsetPercent = this.currentIndex * itemsPerView * (100 / this.slides.length);

    this.track.style.transition = animate ? 'transform 0.5s ease' : 'none';
    this.track.style.transform = `translateX(-${offsetPercent}%)`;

    this.updateDots();
  }

  next() {
    this.goTo(this.currentIndex + 1);
  }

  prev() {
    this.goTo(this.currentIndex - 1);
  }

  startAutoplay() {
    if (!this.autoplay || this.pageCount <= 1) return;
    this.stopAutoplay();
    this.timer = setInterval(() => this.next(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }

  bindEvents() {
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.next(); this.startAutoplay(); });
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.prev(); this.startAutoplay(); });

    this.root.addEventListener('mouseenter', () => this.stopAutoplay());
    this.root.addEventListener('mouseleave', () => this.startAutoplay());

    // Rebuild layout on breakpoint change (desktop <-> mobile item count)
    this.mq.addEventListener('change', () => {
      this.buildDots();
      this.goTo(0, false);
    });

    // Recalculate on resize (debounced)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.goTo(this.currentIndex, false), 150);
    });

    // Basic swipe support for touch devices
    let startX = 0;
    this.viewport.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    this.viewport.addEventListener('touchend', (e) => {
      const diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? this.prev() : this.next();
        this.startAutoplay();
      }
    }, { passive: true });
  }
}

document.querySelectorAll('.customer-stories').forEach((el) => new CustomerStoriesSlider(el));

// Re-init when a section is re-rendered inside the theme editor
document.addEventListener('shopify:section:load', (e) => {
  const el = e.target.querySelector('.customer-stories');
  if (el) new CustomerStoriesSlider(el);
});
